import { ProjectType } from './Types';
import { FileDto } from './fileService';
import { ShortMarket } from './marketsAdminService';

export enum SetupAreaVersionStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface SetupAreaContractTemplate {
  id: number,
  projectType: ProjectType,
  exampleFile: FileDto,
}

export type SetupAreaVersion = {
  version: string,
  description?: string,
  status: SetupAreaVersionStatus,
  contractTemplates: SetupAreaContractTemplate[],
  numberOfDetailFields: number,
  numberOfPlans: number,
  numberOfUsages: number,
}

export type SetupArea = {
  id: number,
  name: string,
  alias: string,
  timezone?: string,
  versions: SetupAreaVersion[]
  isDefault: boolean,
  market?: ShortMarket,
  isCustom: boolean,
}

